"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var style_1 = require("../style");
var style_2 = require("./style");
var Infos = function (_a) {
    var links = _a.links, title = _a.title;
    return (react_1.default.createElement(style_2.Wrapper, null,
        react_1.default.createElement(style_1.ColumnTitle, null, title),
        links.map(function (_a, i) {
            var label = _a.label, props = _a.props;
            return ((label !== undefined)
                ? (react_1.default.createElement("div", { className: 'MainSection__Column__LinkWrapper', key: i + "-" + label.replace(/\s+/g, '-') },
                    react_1.default.createElement("a", __assign({ className: 'MainSection__Column__Link' }, props), label))) : null);
        })));
};
exports.default = Infos;
